<template>
  <section class="campaign">
    <Header :user="user" />
    <main class="main">
     <MyTeam />
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import MyTeam from "@/components/Team/MyTeam.vue"


export default {
  components: {
    Header,
    MyTeam
  },

  computed: {
    ...mapState({
      headerTab: state => state.header.tab
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
  mounted() {
    this.udpdateHeader("team");
  },
  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
  }
};
</script>
